





import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Editor as TipTapEditor, EditorContent } from '@tiptap/vue-2';
import Text from '@tiptap/extension-text';
import type { ITextContentDoc } from '@getaccept/editor-lib';
import { InputDocNode, EnterBreakNode, ParagraphNode } from '@getaccept/editor-lib';

@Component({
  components: {
    EditorContent,
  },
})
export default class ProsemirrorViewerInput extends Vue {
  @Prop() content: ITextContentDoc;
  @Watch('content') setContent() {
    this.viewer.commands.setContent(this.content);
  }

  viewer: TipTapEditor | null = null;

  get inputViewer() {
    return {
      content: this.content,
      editable: false,
      extensions: [InputDocNode, ParagraphNode, Text, EnterBreakNode],
      onCreate: this.handleLoaded,
      enableInputRules: false,
      enablePasteRules: false,
    };
  }

  handleLoaded() {
    Vue.nextTick(() => {
      this.$emit('loaded');
    });
  }

  mounted() {
    this.viewer = new TipTapEditor(this.inputViewer);
  }

  beforeDestroy() {
    this.viewer.destroy();
  }
}
